import Vue from "vue";

export const getAll = ({ commit }) =>
  Vue.$axios
    .get("faqs/")
    .then(result => commit("SET_ALL", result.data))
    .catch(() => Promise.reject());
